<template>
  <div class="outer_banner_workshop">
    <div class="container">
      <div class="banner">
        <div class="inner_center">
          <span class="badge">
            Live online series
          </span>
          <div class="headings">
            <!-- <h1 class="worhshop-name">Presentation Hacks for Teens</h1> -->
            <h1 class="workshop-name">
              {{ this.workshopName }}
            </h1>
            <!-- <h4 class="author">by Rafeed Elahi Chowdhury</h4> -->
          </div>
          <div class="workshop-bar">
            <div class="date">
              <i class="fa fa-calendar-check-o fa-lg font_awesome"></i>
              <p class="work_bar_name">Starts: {{ this.getDate }}</p>
            </div>
            <div class="time">
              <i class="fa fa-clock-o fa-lg font_awesome"></i>

              <p class="work_bar_name">
                Time: {{ this.getTime }}-{{ this.getEndTime }}
              </p>
            </div>
          </div>
          <div class="wrk-class" v-if="this.cls.length > 0">
            <i class="fa fa-book fa-lg"></i>
            <p class="work_bar_name">Class: {{ this.cls.length }} classes</p>
          </div>
          <!-- <div class="days">
        <i class="fa fa-calendar fa-lg"></i> Days: 6 Days/week
      </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import { mapActions } from "vuex";
var moment = require('moment')
export default {
  name: 'workshopBanner',
  props: ['workshopName', 'trainerName', 'timestamp', 'duration', 'cls'],

  computed: {
    getTime() {
      return moment(this.timestamp).format('hh:mm a')
    },
    getEndTime() {
      var t = moment(this.timestamp).add(this.duration, 'hours')
      return moment(t).format('hh:mm a')
    },
    getDate() {
      return moment(this.timestamp).format('LL')
    },
    getWrkName() {
      var name = this.workshopName
      return name.substring(name.indexOf('"') + 1, name.lastIndexOf('"'))
    },
  },
}
</script>

<style scoped>
.font_awesome {
  color: #e8ecf1;
  font-size: 30px;
  margin-right: 8px;
}
.date {
  display: flex;
  align-items: center;
}
.time {
  margin-left: 10px;
  display: flex;
  align-items: center;
}
.date p {
  font: 700 1.5rem/1.81rem 'Open Sans';
  letter-spacing: -0.6px;
  color: #e8ecf1;
  text-align: left;
  margin-bottom: 0 !important;
}
.time p {
  font: 700 1.5rem/1.81rem 'Open Sans';
  letter-spacing: -0.6px;
  color: #e8ecf1;
  text-align: left;
  margin-bottom: 0 !important;
  margin-bottom: 0 !important;
}
.inner_center {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.outer_banner_workshop {
  background-color: #0b2a5a;
}
.banner {
  display: flex;
  min-height: 566px;
  background-color: #0b2a5a;
  color: whitesmoke;
  overflow: hidden;
}
.headings {
  margin-top: 1em;
}
.workshop-name {
  font: 700 3rem/3.75rem 'Open Sans';
  max-width: 50%;
}
.badge {
  max-width: 172px;
  background-color: #ff5714;
  padding: 9px 18px;
  border-radius: 3px;
  color: white;
  font: 700 0.875rem/1.687rem 'Open Sans';
  text-transform: uppercase;
  white-space: nowrap;
}
.workshop-bar {
  display: flex;
  justify-content: center;
  background-color: #3800bc;
  border-radius: 5px;
  max-width: 65%;
  min-height: 60px;
  margin-top: 25px;
}
.author {
  font-size: 16px;
  opacity: 70%;
}
@media (max-width: 767.98px) {
  .inner_center {
    padding-bottom: 150px;
  }
  .workshop-name {
    font: 700 3rem/3.75rem 'Open Sans';
    max-width: 100%;
  }
  .banner {
    background-color: #0b2a5a !important;
    color: #ffffff;
    padding: 0 !important;
    min-height: 440px;
  }
  .badge {
    background-color: #ff5714 !important;
    border-radius: 4px;
    padding: 9px 18px;
    color: white;
    font-size: 14px;
    text-align: center;
    text-transform: uppercase;
    line-height: 27px;
    font-weight: 700;
  }
  .workshop-name {
    font-family: 'Open Sans';
    font-size: 24px;
    font-weight: 700;
    text-align: left;
    letter-spacing: -1.2px;
    line-height: 30px;
    /* padding-top: 13px; */
    padding-bottom: 10px;
  }
  .workshop-bar {
    display: flex;
    justify-content: center;
    background-color: #3800bc;
    border-radius: 5px;
    max-width: 100%;
    min-height: 50px;
    margin-top: 10px;
  }

  .work_bar_name {
    font: 700 2rem/1.81rem 'Open Sans';
    letter-spacing: -0.6px;
    color: #e8ecf1;
    text-align: left;
    margin-bottom: 0 !important;
  }
  .font_awesome {
    color: #e8ecf1;
    font-size: 20px;
    margin-right: 8px;
  }
  .date {
    display: flex;
    align-items: center;
  }
  .time {
    margin-left: 10px;
    display: flex;
    align-items: center;
  }
  .date p {
    font: 700 0.8rem/1.81rem 'Open Sans';
    letter-spacing: -0.9px;
    color: #e8ecf1;
    text-align: left;
    margin-bottom: 0 !important;
  }
  .time p {
    font: 700 0.8rem/1.81rem 'Open Sans';

    letter-spacing: -0.9px;
    color: #e8ecf1;
    text-align: left;
    margin-bottom: 0 !important;
    margin-bottom: 0 !important;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  .workshop-bar {
    width: 100%;
  }
}
</style>
